import { render, staticRenderFns } from "./panel_width_resizer.vue.js?vue&type=template&id=3bffb1a4!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./panel_width_resizer.vue?vue&type=template&id=3bffb1a4"
import script from "./panel_width_resizer.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./panel_width_resizer.vue?vue&type=script&lang=js"
export * from "./panel_width_resizer.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./panel_width_resizer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bffb1a4')) {
      api.createRecord('3bffb1a4', component.options)
    } else {
      api.reload('3bffb1a4', component.options)
    }
    module.hot.accept("./panel_width_resizer.vue.js?vue&type=template&id=3bffb1a4!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./panel_width_resizer.vue?vue&type=template&id=3bffb1a4", function () {
      api.rerender('3bffb1a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue_shared/components/panel_width_resizer.vue"
export default component.exports